/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './mouseCursor.css';
export const MOUSE_CURSOR_TEXT_CSS_CLASS_NAME = `monaco-mouse-cursor-text`;



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/base/browser/ui/mouseCursor/mouseCursor.js
// module id = null
// module chunks = 